import {
  type GetApiAdminCompanyByCompanyTreeSettingsIdResponse,
  useGetApiAdminTriggersPackages,
  usePostAdminSyncTriggersPackages,
} from '@sit/client-shared';
import { noop } from '@tanstack/react-query';
import Box from 'carbon-react/lib/components/box';
import Button from 'carbon-react/lib/components/button/__next__';
import Loader from 'carbon-react/lib/components/loader/__next__';
import Textbox from 'carbon-react/lib/components/textbox';
import Typography from 'carbon-react/lib/components/typography';
import toastr from '../../../helpers/toastr';
import { useCompanyTreeSettingsIdInPathParams } from '../helpers';

export interface CompanyUsersPageProps {
  company: GetApiAdminCompanyByCompanyTreeSettingsIdResponse;
}

export function CompanyTriggersPage() {
  const companyTreeSettingsId = useCompanyTreeSettingsIdInPathParams();
  const { mutate: syncTriggersPackages, isPending: isSyncingVersion } =
    usePostAdminSyncTriggersPackages();
  const { data: triggersData, isLoading } = useGetApiAdminTriggersPackages({
    queryParams: {
      companyTreeSettingsId: `${companyTreeSettingsId}`,
    },
  });
  const currentTriggerVersion = triggersData?.packages?.find(
    (p) => p.companyTreeSettingsId === companyTreeSettingsId,
  )?.version;

  const onSync = () => {
    syncTriggersPackages(
      {
        pathParams: {
          companyTreeSettingsId: `${companyTreeSettingsId}`,
        },
      },
      {
        onSuccess: (data) => {
          toastr.success(
            `Latest triggers package version is ${
              data.triggerPackageVersion ?? 'not available'
            }`,
          );
        },
      },
    );
  };

  const packageVersionName = isLoading
    ? 'loading...'
    : (currentTriggerVersion ?? 'not available');

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      width="100%"
      p="1rem"
      gap={4}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="flex-start"
        alignContent="flex-start"
        gap={2}
      >
        <Typography variant="h2">Current trigger package version</Typography>
        <Box display="flex" flexDirection="row">
          <Box minWidth="150px">
            <Textbox value={packageVersionName} readOnly onChange={noop} />
          </Box>
          <Button onClick={() => onSync()} size="small">
            {isSyncingVersion ? (
              <Loader
                loaderType="ring"
                variant="inline"
                size="extra-small"
                loaderLabel="Syncing..."
              />
            ) : (
              'Sync'
            )}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
